export default __webpack_public_path__ + "static/media/missing-token-icon.0c119e4a.svg";